module.exports = __webpack_public_path__ + "img/lunbo61.18b797c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo61.png
// module id = /iLc
// module chunks = 0